/** Шит «🔧 Доп.работа» на дашборде оператора (04.09, владелец: кнопка
 *  «должна открывать модалку создания доп работы»). Внутри — та же форма
 *  заявки, что во вкладке «Доп» (ProposeExtraForm): время от–до + описание
 *  → POST /api/extra-work (proposed). Форма ремаунтится на каждое открытие
 *  (key), но остаётся в DOM на время выезда шита (230мс) — без прыжка высоты.
 *  04.09 (ревью): пока форма отправляет (busy через onBusyChange), «Отмена»,
 *  backdrop и Esc не закрывают шит — иначе старый POST закрывал НОВЫЙ шит
 *  и заявку можно было отправить дважды. busy сбрасываем на открытии. */
import { useEffect, useState } from "react";
import { SheetDialog } from "../../components/shared";
import { fmtDateApi } from "../../utils/date";
import { ProposeExtraForm } from "./ProposeExtraForm";
import css from "./dashActions.module.css";

export function ProposeExtraSheet({ open, date, onClose, onDone }: { open: boolean; date: Date; onClose: () => void; onDone: () => void }) {
  const [k, setK] = useState(0);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setK((n) => n + 1); setBusy(false); } }, [open]);
  const dismiss = () => { if (!busy) onClose(); };
  const d = fmtDateApi(date);
  return (
    <SheetDialog open={open} onDismiss={dismiss} ariaLabel="Заявка на допработу" maxHeight="70dvh">
      <div className={css.sheetHead}>
        <span className={`${css.sheetTitle} ${css.tPink}`}>🔧 Доп.работа — заявка в ОО</span>
        <span className={css.sheetDate}>{d.slice(8, 10)}.{d.slice(5, 7)}</span>
      </div>
      <div className={css.sheetBody}>
        <ProposeExtraForm key={k} date={date} onDone={onDone} onCancel={dismiss} onBusyChange={setBusy} />
        <div className={css.hint}>Ставка встанет из тарифа допработ; время и сумму утверждает ОО.</div>
      </div>
    </SheetDialog>
  );
}
